/* eslint-disable import/no-cycle */
import { ajaxNew as ajax } from '../../../../scanline/utils/ajax';

// eslint-disable-next-line import/prefer-default-export
export const getMultiWireTestStationXLSX = ({
	selected,
	approval,
	searches,
	from = 0,
	size = 50
}) => {
	const url = '/reports/mwts';
	const data = JSON.stringify({ selected, approval, searches, from, size });
	const method = 'POST';

	return ajax({
		url,
		data,
		method,
		aip: 'assetview-exports'
	});
};

export const extra = '';
